import { gql } from '@apollo/client';

export const UPDATE_IMAGE = gql`
  mutation updateImage($input: FileInput!, $file: Upload) {
    updateImage(input: $input, file: $file) {
      id
      key
      url
      result
    }
  }
`;